import { render, staticRenderFns } from "./ToneBannerSection.vue?vue&type=template&id=70f78ad2"
import script from "./ToneBannerSection.vue?vue&type=script&lang=ts"
export * from "./ToneBannerSection.vue?vue&type=script&lang=ts"
import style0 from "./ToneBannerSection.vue?vue&type=style&index=0&id=70f78ad2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports